import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function FeetBack() {
	return (
		<g>
			<path className="fill fill--alt foot foot--back foot--inside" d="M263.3526917,282.6105042
				c-2.2128906,21.534668-2.7739258,44.2214355-2.078125,67.7861328l-0.0047607,0.0203857
				c0,9.9409485,9.1487732,14.3233032,27.0380859,14.3233032c17.8892822,0,27.0429077-4.3823547,27.0429077-14.3233032v-0.0204468
				c0-41.6942749,0-67.7859192-40.3345642-67.7859192L263.3526917,282.6105042z" />
			<path className="fill fill--alt foot foot--front foot--outside" d="M179.2938995,282.6105042
				c2.2128906,21.534668,2.7739258,44.2214355,2.078125,67.7861328l0.004776,0.0203857
				c0,9.9409485-9.1487885,14.3233032-27.0380859,14.3233032s-27.0429077-4.3823547-27.0429077-14.3233032v-0.0204468
				c0-41.6942749,0-67.7859192,40.334549-67.7859192L179.2938995,282.6105042z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/FeetBack.js